import { useMemo } from "react";
import {
    Folder,
    Pin,
    Star,
    FolderPlus,
    X,
    LayoutList
} from "lucide-react";

export default function MediaListsSection({

    media,
    onAdd,
    onRemove

}) {

    const lists = useMemo(

        () => media?.lists || [],

        [media]

    );

    return (

        <div className="media-lists-card">

            <div className="media-section-header">

                <div className="media-section-title">

                    <LayoutList size={18}/>

                    <span>

                        Lists

                    </span>

                </div>

                <button

                    className="list-add-btn"

                    onClick={() => onAdd?.(media)}

                >

                    <FolderPlus size={16}/>

                    Add

                </button>

            </div>

            {

                lists.length

                    ?

                    <div className="media-list-items">

                        {

                            lists.map(list => (

                                <div

                                    key={list.id}

                                    className="media-list-item"

                                >

                                    <div className="media-list-left">

                                        <div className="media-list-icon">

                                            {

                                                list.pinned

                                                    ? <Pin size={15}/>

                                                    : list.favorite

                                                    ? <Star size={15}/>

                                                    : <Folder size={15}/>

                                            }

                                        </div>

                                        <div>

                                            <div className="media-list-name">

                                                {list.name}

                                            </div>

                                            <div className="media-list-count">

                                                {list.totalFiles || 0} files

                                            </div>

                                        </div>

                                    </div>

                                    <button

                                        className="remove-btn"

                                        onClick={() =>

                                            onRemove?.(

                                                list.id,

                                                media.id,

                                                list.name

                                            )

                                        }

                                    >

                                        <X size={15}/>

                                    </button>

                                </div>

                            ))

                        }

                    </div>

                    :

                    <div className="empty-lists">

                        <Folder size={56}/>

                        <h4>

                            No Lists

                        </h4>

                        <p>

                            This media isn't assigned to any list yet.

                        </p>

                    </div>

            }

            <style>{`

.media-lists-card{

    background:#FFF;

    border:1px solid #E5E7EB;

    border-radius:18px;

    padding:20px;

    box-shadow:
        0 1px 2px rgba(15,23,42,.05);

}

.media-section-header{

    display:flex;

    justify-content:space-between;

    align-items:center;

    margin-bottom:18px;

}

.media-section-title{

    display:flex;

    align-items:center;

    gap:10px;

    font-size:17px;

    font-weight:700;

    color:#0F172A;

}

.media-section-title svg{

    color:#2563EB;

}

.list-add-btn{

    display:flex;

    align-items:center;

    gap:8px;

    height:38px;

    padding:0 14px;

    border:none;

    border-radius:10px;

    background:#EEF4FF;

    color:#2563EB;

    font-size:13px;

    font-weight:600;

    cursor:pointer;

    transition:.18s;

}

.list-add-btn:hover{

    background:#DBEAFE;

}

.media-list-items{

    display:flex;

    flex-direction:column;

    gap:12px;

}

.media-list-item{

    display:flex;

    justify-content:space-between;

    align-items:center;

    padding:12px;

    border-radius:14px;

    background:#F8FAFC;

    transition:.18s;

}

.media-list-item:hover{

    background:#F1F5F9;

}

.media-list-left{

    display:flex;

    align-items:center;

    gap:14px;

}

.media-list-icon{

    width:40px;

    height:40px;

    border-radius:12px;

    background:#EFF6FF;

    color:#2563EB;

    display:flex;

    align-items:center;

    justify-content:center;

}

.media-list-name{

    font-weight:600;

    color:#0F172A;

}

.media-list-count{

    margin-top:3px;

    font-size:12px;

    color:#64748B;

}

.remove-btn{

    width:34px;

    height:34px;

    border:none;

    border-radius:10px;

    background:#FFF;

    color:#64748B;

    display:flex;

    align-items:center;

    justify-content:center;

    cursor:pointer;

    transition:.18s;

}

.remove-btn:hover{

    background:#FEE2E2;

    color:#DC2626;

}

.empty-lists{

    display:flex;

    flex-direction:column;

    align-items:center;

    justify-content:center;

    gap:10px;

    padding:36px 20px;

    text-align:center;

    color:#64748B;

}

.empty-lists svg{

    color:#CBD5E1;

}

.empty-lists h4{

    margin:0;

    color:#334155;

}

.empty-lists p{

    margin:0;

    max-width:260px;

    line-height:1.5;

}

`}</style>

        </div>

    );

}